import React, { Component } from 'react'
import './textOnly.css'

class TextOnly extends Component {

  handleValue (value) {
    this.props.updateValue(value)
  }

  clearInput() {
    this.props.updateValue('')
  }

  handleSubmit(value) {
    this.props.handleValueSubmit(value)
    this.clearInput()
  }

  handleKeyDown(event) {
    if (event.keyCode === 13) {
      this.handleSubmit(this.props.value)
    }
    this.props.scroll()
  }

  render() {
    return(
      <div className="text-input-group">
        <input
          className='single-line-input'
          onChange={(event) => this.handleValue(event.target.value)}
          value={this.props.value}
          autoFocus={true}
          onKeyDown={(event) => this.handleKeyDown(event)}
          placeholder={this.props.placeholder}
        />
      </div>
    )
  }
}

export default TextOnly
